// Names: letters and spaces only (e.g. "Mary Jane"), aligned with backend name validation.
// Empty values are skipped so the `required` rule wins first.
export const validateOnlyLettersAndSpaces = (value: string | undefined | null) =>
  !value || /^[a-zA-Z ]+$/.test(value) || 'Should contain only letters';
